<template>
  <v-app>
    <SiteHeader :walletConnect="walletConnect" />
    <v-container fluid>
      <v-row no-gutters>
        <v-navigation-drawer
          v-model="drawer"
          app
          :permanent="!isMobile"
          :mini-variant="!drawer"
          width="250"
          mini-variant-width="56"
        >
          <Sidebar @toogle-wallet-connection="toggleWalletConnection" />
        </v-navigation-drawer>
        <v-main>
          <router-view v-if="isConnected" :walletConnect="walletConnect"></router-view>
        </v-main>
      </v-row>
    </v-container>
    <SiteFooter />
  </v-app>
</template>
<script>
import emitter from '@/utils/eventBus';
import Sidebar from './user/Sidebar.vue';
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import WalletConnect from "@/utils/walletConnect";
  export default {
    name: 'UserCenter',
    components: {
      Sidebar,
      SiteHeader,
      SiteFooter,
    },
    data() {
      return {
        drawer: false,
        loading: false,
        walletConnect: null,
        isConnected: false,
      };
    },
    computed: {
      isUserLoggedIn() {
        // Logic to check if user is logged in
        return true; // Replace with actual logic
      },
      isMobile() {
        return window.innerWidth < 960;
      },
    },
    methods: {
      setLoading(value) {
        this.loading = value;
        if(value) {
          this.$toast.showMarkLoading();
        } else {
          this.$toast.hideMarkLoading();
        }
      },
      toggleDrawer() {
        this.drawer = !this.drawer;
      },
      toggleWalletConnection() {
        emitter.emit('toogle-wallet-connection');
        console.log('toggleWalletConnection');
      },
    },
    beforeMount() {
      this.walletConnect = new WalletConnect(this.$router, this.setLoading);
      emitter.off('toogle-drawer');
    },
    mounted() {
      this.$eventBus.on('walletConnectInitialized', ()=> {
        this.isConnected = true;
      });
      emitter.on('toogle-drawer', this.toggleDrawer);
      if (!this.isUserLoggedIn) {
        this.$router.push('/');
      }
    },
  };
  </script>
  
  <style scoped>
 .v-main {
  flex-grow: 1;
  overflow: auto;
  padding-top: 84px !important; /* 确保内容不被头部遮挡 */
}
  </style>